var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLengehRail31Right2Right3Fix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 33.3",
    enableBackground: "new 0 0 66 33.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4,1.5h20.2v30.3H2.4V1.5 M1.4,0.5v32.3h22.2V0.5H1.4L1.4,0.5z M7.4,6.5h10.2v20.3H7.4V6.5 M6.4,5.5v22.3h12.2V5.5H6.4 L6.4,5.5z M23.4,1.5 M23.4,1.5h19.7v30.3H23.4l-1,1l21.7,0V0.5H22.4l0,0L23.4,1.5 M23.9,6.5 M23.9,6.5l14.2,0v20.3H22.9v1h16.2V5.5 H22.9l0,0v1 M43.9,1.5 M43.9,1.5h19.7v30.3H43.9l-1,1h21.7V0.5H42.9l0,0L43.9,1.5 M44.4,6.5 M44.4,5.2h15.2v22.8H43.4v1h17.2V4.2 H43.4v1.5V5.2 M8.4,17.2h5.5v-1H8.4V17.2z M16.7,16.6l-3.3-3.3v6.6L16.7,16.6z M26.7,17.2h5.5v-1h-5.5V17.2z M35,16.6l-3.3-3.3v6.6 L35,16.6z M55.8,16.2h-7.7v1h7.7V16.2z M52.5,12.8h-1v7.7h1V12.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengehRail31Right2Right3Fix);
export default __webpack_public_path__ + "static/media/LENGEH_RAIL_3_1RIGHT_2RIGHT_3FIX.24daf1ae64cda296f8aa564e6312588e.svg";
export { ForwardRef as ReactComponent };